<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item label="ID" >
          <el-input v-model="filters.id" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户名" >
          <el-input v-model="filters.userName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="提问时间" >
          <el-date-picker
            v-model="filters.createTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="发送状态" >
          <el-select v-model="filters.release"  style="width: 120px;" >
            <el-option label="全部" value="2"></el-option>
            <el-option label="未发送"   value="0"></el-option>
            <el-option label="已发送" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" >
          <el-select v-model="filters.state"  style="width: 120px;" >
            <el-option label="全部" value="2"></el-option>
            <el-option label="未审核" value="0"></el-option>
            <el-option label="已审核"   value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" v-on:click="getInitList">查询</el-button>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" @click="handleBatdchDel" v-if="buttonsAccessList.indexOf('批量删除') > -1" >批量删除</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="questionList" highlight-current-row v-loading="listLoading" @selection-change="handleSelectionChange" style="width: 100%;" border>
      <el-table-column
        type="selection"
        width="50">
      </el-table-column>
      <el-table-column prop="questionId" label="问题ID" width="140" >
      </el-table-column>
      <el-table-column prop="questionStr" label="问题内容" width="480" show-overflow-tooltip >
      </el-table-column>
      <el-table-column prop="userName" label="用户名" min-width="200" >
      </el-table-column>
      <el-table-column prop="isRelease" label="发送状态" min-width="120" :formatter="formatRelease" >
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="180" >
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" @click="handleSendEmail(scope.$index, scope.row)" v-if="buttonsAccessList.indexOf('发送') > -1">发送邮件</el-button>
          <el-button size="small" @click="handleAudit(scope.$index, scope.row)" v-if=" buttonsAccessList.indexOf('审核') > -1 &&  scope.row.state ==0">审核</el-button>
          <el-button size="small" @click="handleCancelAudit(scope.$index, scope.row)" v-if=" buttonsAccessList.indexOf('取消审核') > -1 &&  scope.row.state ==1">取消审核</el-button>
          <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)" v-if="buttonsAccessList.indexOf('删除') > -1">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :current-page="currentPage">
      </el-pagination>
    </el-col>

    <!--发送邮件页面-->
    <el-dialog title="发送邮件" :visible.sync="sendFormVisible" :close-on-click-modal="false">
      <el-form :model="sendForm" label-width="80px" ref="sendForm" >
        <el-form-item label="问题内容" label-width="100px">
          <el-input type="textarea" :rows=6 v-model.trim="sendForm.qustionDes" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="sendFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="sendSubmit()" :loading="sendLoading">发送邮件</el-button>
      </div>
    </el-dialog>


    <!--审核页面-->
    <el-dialog title="审核" :visible.sync="auditFormVisible" :close-on-click-modal="false">
      <el-form :model="auditForm" label-width="80px" ref="auditForm" :rules="auditFormRules">
        <el-form-item label="问题内容" label-width="100px" prop="qustionDes">
          <el-input type="textarea" :rows=6 v-model.trim="auditForm.qustionDes" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="回复者" label-width="100px" prop="answerName">
          <el-input type="text" v-model.trim="auditForm.answerName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="回复内容" label-width="100px" prop="answerStr">
          <el-input type="textarea" :rows=6 v-model.trim="auditForm.answerStr" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="auditFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="auditSubmit()" :loading="auditLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import util from '../../common/js/util'

  import { getQuestionList,deleteQuestion,sendEmail,auditQuestion,batchDelQuestion} from '../../api/api';
  export default {
    data() {
      return {
        buttonsAccessList:this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[110101]?this.$storejs.get(process.env.VUE_APP_APPKEY+"userAccess")[110101].buttons:[],
        filters: {
          id: '',
          release:'2',
          createTime:'',
          state:'2',
          userName:''
        },
        sendForm:{
          id:'',
          qustionDes:''
        },
        auditForm:{
          id:'',
          qustionDes:'',
          answerName:'',
          answerStr:''
        },
        auditFormRules: {
          qustionDes: [
            { required: true, message: '请填写问题', trigger: 'blur' }
          ],
          answerName: [
            { required: true, message: '请填写回复者', trigger: 'blur' }
          ],
          answerStr: [
            { required: true, message: '请填写回复内容', trigger: 'blur' }
          ],
        },
        sendFormVisible:false,
        auditFormVisible:false,
        multipleSelection: [],//全选数组
        questionList: [],
        total: 0,
        pageSize:10,
        page: 1,
        addFormTtile:'',
        currentPage:1,
        listLoading: false,
        sels: [],//列表选中列
        auditLoading:false,
        sendLoading: false,
      }
    },
    methods: {
      formatRelease: (row)=> {
        return row.isRelease == 1 ? '已发送' : '未发送' ;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getInitList();
      },

      handleSelectionChange(val) {//多选
        this.multipleSelection = val;
      },

      //获取问答列表
      getInitList() {
        let param = {
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            id:this.filters.id,
            release:this.filters.release,
            userName:this.filters.userName,
            state:this.filters.state,
            createTime:(! this.filters.createTime ||  this.filters.createTime == '') ? '' : util.formatDate.format(new Date( this.filters.createTime), 'yyyy-MM-dd')
        };
        this.listLoading = true;
        getQuestionList(param).then((res) => {
          this.total = res.data.data.total;
          this.questionList = res.data.data.list;
          this.listLoading = false;
        });
      },

      handleBatdchDel(){
        this.$confirm('此操作将永久删除选中项目, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var _this = this;
          const formData = new FormData();
          var po="";
          for (var index in  this.multipleSelection){
            po+=this.multipleSelection[index].questionId+","
          }
          if(po.length>1){
            po=po. substring(0,po.length-1)
          }else{
            _this.$message({
              type: 'warning',
              message: '请选择删除'
            });
            return false;
          }
          formData.append('ids', po);
          batchDelQuestion(formData).then(function (response) {
            var data = response.data
            if (data.status == 200) {
              _this.$message({
                type: 'success',
                message: data.msg
              });
              _this.getInitList()
            } else {
              _this.$message({
                type: 'warning',
                message: data.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //显示发送邮件页面
      handleSendEmail(index, row) {
        if(row.isRelease ==1 ){
          this.$message({
            type: 'warning',
            message: '该提问只能回复一次！'
          });
          return;
        }

        this.sendFormVisible = true;
        this.sendForm.id=row.questionId;
        this.sendForm.qustionDes=row.questionStr;
      },

      handleAudit(index, row){
        this.auditFormVisible = true;
        this.auditForm.id=row.questionId;
        this.auditForm.qustionDes=row.questionStr;
        this.auditForm.answerStr=row.answerStr;
        this.auditForm.answerName=row.answerName;
      },

      handleCancelAudit(index, row) {//删除产品
        this.$confirm('确认要取消审核吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.questionId);
          formData.append('type', 2);
          auditQuestion(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$notify({
                type: 'success',
                message: data.msg
              });
              this.getInitList()
            } else {
              this.$notify({
                type: 'warning',
                message: data.msg
              });
            }
          })
        });
      },

      handleDel(index, row) {//删除产品
        if(row.state ==1 ){
          this.$message({
            type: 'warning',
            message: '该记录已被审核，请取消审核后再删除！'
          });
          return;
        }
        this.$confirm('确认要删除该资讯吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const formData = new FormData();
          formData.append('id', row.questionId);
          formData.append('isDel', 0);
          deleteQuestion(formData).then((response) => {
            var data = response.data
            if (data.status == 200) {
              this.$notify({
                type: 'success',
                message: data.msg
              });
              this.getInitList()
            } else {
              this.$notify({
                type: 'warning',
                message: data.msg
              });
            }
          })
        })
      },

      //发送邮件并保存记录
      sendSubmit: function () {
        this.sendLoading = true;
        const formData = new FormData();
        formData.append('id', this.sendForm.id);
        formData.append('isRelease', 1);
        formData.append('qustionDes', this.sendForm.qustionDes);
        sendEmail(formData).then((res) => {
          if(res.data.status == 200){
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.sendFormVisible = false;
            this.sendLoading = false;
            this.getInitList();
          }else{
            this.sendLoading = false;
            this.$notify({
              title: '失败',
              message: '操作失败',
              type: 'fail'
            });
          }
        });
      },
      auditSubmit:function(){
        this.$refs.auditForm.validate((valid) => {
          if (valid) {
            this.auditLoading = true;
            const formData = new FormData();
            formData.append('id', this.auditForm.id);
            formData.append('type', 1);
            formData.append('qustionDes', this.auditForm.qustionDes);
            formData.append('answerStr', this.auditForm.answerStr);
            formData.append('answerName', this.auditForm.answerName);
            auditQuestion(formData).then((res) => {
              if(res.data.status == 200){
                this.$notify({
                  title: '成功',
                  message: '操作成功',
                  type: 'success'
                });
                this.auditFormVisible = false;
                this.auditLoading = false;
                this.getInitList();
              }else{
                this.auditLoading = false;
                this.$notify({
                  title: '失败',
                  message: '操作失败',
                  type: 'fail'
                });
              }
            });
          }
        });
      },
      selsChange: function (sels) {
        this.sels = sels;
      },
    },
    mounted() {
      this.getInitList();
    }
  }
</script>

<style scoped>
</style>
